exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coverage-code[data-v-45326e20] {\n  width: 100%;\n}\n.amount[data-v-45326e20] {\n  width: 160px;\n}", ""]);

// exports
